import { gql } from '@apollo/client';

export const GET_ORG_INFO = gql`
  query GetOrgInfo {
    orgName
    orgId
    orgDateCreated
    smsEnabled
    isLargeOrg
    vm {
      configItem(key: "allow-general-role-applications") {
        configItemValue {
          flagValue
        }
        defaultValue
      }
    }
    tm {
      tenant {
        billing {
          package {
            packageType
            integrations
            insights
            rostering
            bulletins
            incidents
            attendanceBackup
            sms
            forms
          }
        }
        menuLabels {
          dashboardHome
          dashboardResources
          dashboardImpact
          volunteeringActivities
          volunteeringActivityReport
          volunteeringIncidentReport
          managementDashboard
          managementActivityManagement
          managementRosters
          managementVolunteers
          managementBulletins
          managementReportManagement
          managementIncidentManagement
          adminTaskManagement
          adminFormsSurveys
          adminProgramManagement
          adminConsole
          wordActivity
          wordRoster
          wordProgram
        }
        dateDeactivated
        config {
          inTrial
          availabilityRestrictionDays
          chatEnabled
        }
      }
    }
  }
`;
